import React from 'react';
import { useTranslation } from '../shared/i18n';
import useDocumentTitle from '../shared/hooks/useDocumentTitle';
import LinksSection from '../shared/components/LinksSection';
import * as S from './EnlacesPage.styles';

function EnlacesPage() {
  const t = useTranslation();
  useDocumentTitle();

  return (
    <S.PageContainer>
      <S.Header>
        <S.Title>{t('links.title')}</S.Title>
        <S.Subtitle>{t('links.subtitle')}</S.Subtitle>
      </S.Header>
      
      <S.ContentSection>
        <LinksSection />
      </S.ContentSection>
    </S.PageContainer>
  );
}

export default EnlacesPage;


